const select = {
  variants: {

  },
}

export default select;
